import { createStyles } from '@/styles';

export default createStyles(() => ({
  classes: {
    overlay: '',
  },
}));
